<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div>
    <ik-data-table
      ref="table"
      :model="model"
      :uuse-custom-action="true"
      entity-name="discountRule"
      icon="mdi-label"
    >
      <template #item.action="{item}">
        <v-list-item
          @click="showTimeFor(item.id)"
        >
          <v-list-item-title>
            {{ $t('setWorkTime') }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          @click="showDishFor(item.id)"
        >
          <v-list-item-title>
            {{ $t('setWorkDish') }}
          </v-list-item-title>
        </v-list-item>
      </template>
    </ik-data-table>
    <v-navigation-drawer
      v-model="showDishDialog"
      :width="$vuetify.breakpoint.mobile ? '100%' : 'min(calc(100vw - 300px),1000px)'"
      app
      color="#fafbfc"
      right
      temporary
      touchless
    >
      <v-container>
        <ik-data-table
          v-if="activeSelectDiscount&&showDishDialog"
          :filter="filter2"
          :model="dishModel"
          :use-add-action="false"
          :use-delete-action="false"
          :use-edit-action="false"
          entity-name="discountDishList"
          icon="mdi-account-child"
        >
          <template
            #navigation
          >
            <back-button @close-event="showDishDialog=false" />
          </template>
        </ik-data-table>
      </v-container>
    </v-navigation-drawer>
    <v-navigation-drawer
      v-model="showTimeDialog"
      :width="$vuetify.breakpoint.mobile ? '100%' : 'min(calc(100vw - 300px),1000px)'"
      app
      color="#fafbfc"
      right
      style="z-index: 10;"
      temporary
      touchless
    >
      <v-container>
        <ik-data-table
          v-if="activeSelectDiscount&&showTimeDialog"
          :fixed-filter="filter"
          :model="timeModel"
          entity-name="timeSetting"
          icon="mdi-account-child"
        >
          <template
            #navigation
          >
            <back-button @close-event="showTimeDialog=false" />
          </template>
        </ik-data-table>
      </v-container>
    </v-navigation-drawer>
  </div>
</template>

<script>
import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import DiscountRules from '@/model/dataLayer/api/discount/DiscountRules'
import DishesDiscountList from '@/model/dataLayer/api/dish/DishesDiscountList'
import DishesDiscountTimeSpan from '@/model/dataLayer/api/discount/DishesDiscountTimeSpan'
import BackButton from '@/views/widget/uiComponent/BackButton.vue'

export default {
  components: {
    IkDataTable,
    BackButton
  },
  data: function () {
    return {
      model: DiscountRules,
      activeSelectDiscount: null,
      dishModel: DishesDiscountList,
      timeModel: DishesDiscountTimeSpan,
      showTimeDialog: null,
      showDishDialog: null

    }
  },
  computed: {
    filter: function () {
      return this.activeSelectDiscount ? { discountRuleId: this.activeSelectDiscount } : null
    },
    filter2: function () {
      return this.activeSelectDiscount ? { ruleId: this.activeSelectDiscount } : null
    }
  },
  methods: {
    showTimeFor (id) {
      console.log(id)
      this.activeSelectDiscount = id
      this.showTimeDialog = true
    },
    showDishFor (id) {
      this.activeSelectDiscount = id
      this.showDishDialog = true
    }
  }
}
</script>
